module.exports = __webpack_public_path__ + "static/media/zfcg.c39e2a6e.svg";